/**
 * 홈페이지 콘텐츠 모델 (CMS 편집용)
 * --------------------------------------------------
 * 구조: pages[] → sections[] → fields[]
 * field.type:
 *   - 'text'     : 한 줄 입력
 *   - 'textarea' : 여러 줄 입력
 *   - 'list'     : 문자열 배열 (항목 추가/삭제)
 *   - 'cards'    : 반복 그룹. subfields[] 로 하위 필드 정의 (재귀 가능)
 *
 * 현재는 UI(편집기) 전용 초기 데이터입니다.
 * 추후 백엔드/DB 연동 시 이 구조를 그대로 API 응답에 매핑하면 됩니다.
 */

export const SITE_CONTENT = [
  /* ───────────────────────── 메인 ───────────────────────── */
  {
    id: 'home',
    label: '메인',
    previewPath: '/',
    sections: [
      {
        id: 'hero',
        title: '히어로 슬라이더',
        fields: [
          {
            key: 'slides',
            label: '슬라이드',
            type: 'cards',
            itemLabel: '슬라이드',
            subfields: [
              { key: 'eyebrow', label: '상단 문구', type: 'text' },
              { key: 'title', label: '제목', type: 'text' },
              { key: 'desc', label: '설명', type: 'textarea' },
            ],
            value: [
              {
                eyebrow: '우수한 성능 및 맞춤형 서비스를 위한 KC 인증 · ISO 9001 품질 경영 시스템',
                title: '산업용 팬리스 PC Solution',
                desc: '구체적인 요구사항을 정확하게 반영한 시스템 플랫폼 솔루션으로 제공합니다.',
              },
              {
                eyebrow: '철도 제어 및 신호 적용을 위한 SIL4 인증 COTS Fail-Safe & Fault-Tolerant System',
                title: 'ControlSafe™ Platforms',
                desc: 'TÜV SÜD로부터 SIL4 인증을 받은 ControlSafe™ 플랫폼을 제공합니다.',
              },
              {
                eyebrow: '30년 이상 국내 군수·항공 시장에서 선두 주자 역할을 해온 고가용성 시스템',
                title: 'Embedded Solution',
                desc: 'Embedded Solution, M&S Solution, Middleware Solution, RTOS 등 우수한 제품을 제공합니다.',
              },
              {
                eyebrow: '사물인터넷(IoT) 디바이스 영역 강화를 위한 전문 맞춤형 컨설팅 서비스',
                title: 'IoT 디바이스 관리 플랫폼',
                desc: '구체적인 요구사항을 정확하게 반영한 디바이스 플랫폼 솔루션으로 제공합니다.',
              },
            ],
          },
        ],
      },
      {
        id: 'home-sections',
        title: '섹션 제목 / 버튼',
        fields: [
          { key: 'appsTitle', label: '응용 분야 - 제목', type: 'text', value: '응용 분야' },
          { key: 'appsBtn', label: '응용 분야 - 버튼', type: 'text', value: '자세히 보기' },
          { key: 'productsTitle', label: '제품 소개 - 제목', type: 'text', value: '제품 소개' },
          { key: 'servicesTitle', label: '적용 분야 - 제목', type: 'text', value: '적용 분야' },
          {
            key: 'servicesDesc',
            label: '적용 분야 - 설명',
            type: 'textarea',
            value:
              '자체 R&D 센터와 수십 년의 도메인 전문성을 바탕으로, AceTec은 국방·항공우주·철도·산업 자동화를 위한 맞춤형 기술 솔루션을 제공합니다 — 모두 KC 인증 및 ISO 9001을 준수합니다.',
          },
          { key: 'servicesBtn', label: '적용 분야 - 버튼', type: 'text', value: '자세히 보기' },
        ],
      },
      {
        id: 'home-accordion',
        title: '적용 분야 아코디언',
        fields: [
          {
            key: 'items',
            label: '항목',
            type: 'cards',
            itemLabel: '항목',
            subfields: [
              { key: 'title', label: '제목', type: 'text' },
              { key: 'body', label: '내용', type: 'textarea' },
            ],
            value: [
              {
                title: '임베디드 컴퓨팅',
                body: 'Jade, Cobalt, Onyx, Talon, Flexor, Spark 플랫폼을 포함한 보드 레벨 신호 처리 시스템으로, 까다로운 국방·항공우주 환경을 위해 설계되었습니다.',
              },
              {
                title: '산업 & 네트워킹',
                body: 'KC 인증 및 ISO 9001을 준수하는 팬리스 PC, 랙마운트 서버, 네트워크 어플라이언스로, 가혹한 산업 환경에서 24시간 연속 운용을 위해 제작되었습니다.',
              },
              {
                title: '안전 필수 시스템',
                body: '철도 신호 및 열차 제어를 위한 TÜV SÜD SIL4 인증 HIMA ControlSafe™ 플랫폼 — 페일세이프 내결함성 아키텍처로 최고 수준의 운용 안전성을 보장합니다.',
              },
              {
                title: '통신 & 네트워킹',
                body: '방화벽, VPN, UTM, 로드 밸런싱을 위한 Intel/AMD 기반 네트워크 어플라이언스와 데이터센터·통신 인프라용 고성능 NIC.',
              },
              {
                title: '센서 모델링 & 시뮬레이션',
                body: 'HWIL(Hardware-In-the-Loop), MITL(Man-In-the-Loop), 훈련 시뮬레이션 환경을 위한 OKTAL-SE의 고정밀 EO/IR/RF 센서 시뮬레이션.',
              },
              {
                title: '고성능 컴퓨팅 (HPC)',
                body: '머신러닝, 금융 분석, 군사, 의료 영상, 과학 연구를 위한 고밀도 GPU 서버 및 PCIe 확장 시스템.',
              },
            ],
          },
        ],
      },
      {
        id: 'home-consult',
        title: '맞춤형 솔루션 CTA',
        fields: [
          { key: 'title', label: '제목', type: 'text', value: '맞춤형 솔루션이 필요하신가요?' },
          {
            key: 'desc',
            label: '설명',
            type: 'textarea',
            value:
              '당사 엔지니어가 플랫폼 선정과 시스템 설계부터 구축, 지속적인 지원까지 미션 크리티컬 애플리케이션을 위한 엔드투엔드 컨설팅을 제공합니다.',
          },
          { key: 'btn', label: '버튼', type: 'text', value: '상담 요청' },
        ],
      },
      {
        id: 'home-plans',
        title: '토탈 서비스 솔루션',
        fields: [
          { key: 'title', label: '제목', type: 'text', value: '토탈 서비스 솔루션' },
          {
            key: 'subtitle',
            label: '부제목',
            type: 'textarea',
            value:
              '초기 시스템 컨설팅부터 최종 납품까지 프로젝트의 모든 단계를 지원하며, 고객 환경에 적용되는 제품과 솔루션에 맞춘 개발 및 기술 서비스를 제공합니다.',
          },
          {
            key: 'plans',
            label: '플랜',
            type: 'cards',
            itemLabel: '플랜',
            subfields: [
              { key: 'title', label: '제목', type: 'text' },
              { key: 'step', label: '단계', type: 'text' },
              { key: 'period', label: '기간', type: 'text' },
              { key: 'desc', label: '설명', type: 'textarea' },
            ],
            value: [
              {
                title: '컨설팅 & 설계',
                step: 'Step 1–2',
                period: '고객 컨설팅 · 설계 컨설팅',
                desc: '프로젝트 요구사항을 분석하고 맞춤형 시스템 설계를 수립하여, 처음부터 최적의 하드웨어·소프트웨어·통합 방식을 보장합니다.',
              },
              {
                title: '구축 & 지원',
                step: 'Step 3–4',
                period: '시스템 구축 · 기술 지원',
                desc: '조달과 시스템 구축을 안내하고, 프로젝트 전 주기에 걸쳐 구축된 솔루션에 대한 실질적인 기술 지원을 제공합니다.',
              },
              {
                title: '검증 & 검사',
                step: 'Step 5',
                period: '제품 평가 · 품질 보증',
                desc: '납품되는 모든 시스템이 프로젝트 사양, 업계 표준, 성능 기준을 충족하는지 엄격한 시험과 평가로 검증합니다.',
              },
            ],
          },
          { key: 'btn', label: '문의하기 버튼', type: 'text', value: '문의하기' },
        ],
      },
      {
        id: 'home-about',
        title: 'AceTec 소개',
        fields: [
          { key: 'title', label: '제목', type: 'text', value: 'AceTec 소개' },
          {
            key: 'desc',
            label: '설명',
            type: 'textarea',
            value:
              '1994년 설립 이래 AceTec은 한국 임베디드 컴퓨팅 및 산업 기술 시장의 선두에 있었습니다. 자체 R&D 센터와 Abaco Systems, HIMA, Wind River, RTI, OKTAL-SE, OSS와의 전략적 파트너십을 통해, 30년 이상의 깊은 엔지니어링 전문성을 바탕으로 국방·항공우주·철도·산업 자동화를 위한 미션 크리티컬 솔루션을 제공합니다.',
          },
          { key: 'btn', label: '버튼', type: 'text', value: '자세히 보기' },
          { key: 'partnersTitle', label: '기술 파트너사 - 제목', type: 'text', value: '기술 파트너사' },
          { key: 'partnersBtn', label: '기술 파트너사 - 버튼', type: 'text', value: '자세히 보기' },
          { key: 'contactTitle', label: '문의하기 - 제목', type: 'text', value: '문의하기' },
          {
            key: 'contactDesc',
            label: '문의하기 - 설명',
            type: 'textarea',
            value:
              '제품 견적, 기술 상담, 파트너십 검토 등 무엇이든 당사 엔지니어링 팀이 도와드립니다. RFQ, 시스템 설계 논의, 프로젝트별 문의 등 언제든 연락 주세요.',
          },
        ],
      },
    ],
  },

  /* ───────────────────────── 솔루션 ───────────────────────── */
  {
    id: 'solutions',
    label: '솔루션',
    previewPath: '/solutions',
    sections: [
      {
        id: 'solutions-cards',
        title: '분야 카드',
        fields: [
          {
            key: 'cards',
            label: '분야',
            type: 'cards',
            itemLabel: '분야',
            subfields: [
              { key: 'title', label: '분야명 (한글)', type: 'text' },
              { key: 'subtitle', label: '영문 부제', type: 'text' },
              { key: 'desc', label: '설명', type: 'textarea' },
              { key: 'image', label: '이미지 경로', type: 'text' },
            ],
            value: [
              {
                title: '국방 & 항공우주',
                subtitle: 'Defense-Grade Computing',
                desc: '정밀 타격, C2, 감시, 무인 체계 등 가장 가혹한 운용 환경을 위해 설계된 견고한 VPX/VME 보드 및 신호 처리 플랫폼.',
                image: 'images/services/military-aerospace.png',
              },
              {
                title: '철도 교통',
                subtitle: 'SIL4 Safety Systems',
                desc: 'CBTC, 연동(interlocking), 열차 제어를 위한 TÜV SÜD SIL4 인증 HIMA ControlSafe™ 플랫폼 — 철도 신호 분야 최고 수준의 안전 무결성을 제공합니다.',
                image: 'images/services/railway.png',
              },
              {
                title: '산업 자동화',
                subtitle: 'Industrial-Grade Platforms',
                desc: '공장 자동화, 공정 제어, 반도체 제조, 품질 검사를 위한 팬리스 산업용 PC, 네트워크 어플라이언스, IoT 플랫폼.',
                image: 'images/services/industrial.png',
              },
              {
                title: '통신 & 네트워킹',
                subtitle: 'Network Infrastructure',
                desc: '방화벽, VPN, UTM, 로드 밸런싱을 위한 Intel/AMD 기반 네트워크 어플라이언스와 데이터센터·통신 인프라용 고성능 NIC 어댑터.',
                image: 'images/services/industrial.png',
              },
              {
                title: '센서 모델링 & 시뮬레이션',
                subtitle: 'OKTAL-SE Solutions',
                desc: 'HWIL(Hardware-In-the-Loop), MITL(Man-In-the-Loop), 훈련 시뮬레이션 환경을 위한 OKTAL-SE의 고정밀 EO/IR/RF 센서 시뮬레이션.',
                image: 'images/services/military-aerospace.png',
              },
              {
                title: '고성능 컴퓨팅 (HPC)',
                subtitle: 'GPU & Compute Platforms',
                desc: '머신러닝, 금융 분석, 군사, 의료 영상, 과학 연구를 위한 고밀도 GPU 서버 및 PCIe 확장 시스템.',
                image: 'images/services/military-aerospace.png',
              },
            ],
          },
        ],
      },
    ],
  },

  /* ───────────────────────── 적용 분야 ───────────────────────── */
  {
    id: 'applications',
    label: '적용 분야',
    previewPath: '/applications',
    sections: [
      {
        id: 'apps-chapters',
        title: '적용 분야 챕터',
        fields: [
          {
            key: 'chapters',
            label: '챕터',
            type: 'cards',
            itemLabel: '챕터',
            subfields: [
              { key: 'title', label: '제목', type: 'text' },
              { key: 'meta', label: '메타(부제)', type: 'text' },
              {
                key: 'lessons',
                label: '소개 항목',
                type: 'cards',
                itemLabel: '항목',
                subfields: [
                  { key: 'title', label: '제목', type: 'text' },
                  { key: 'desc', label: '설명', type: 'textarea' },
                  { key: 'tag', label: '태그', type: 'text' },
                ],
              },
              {
                key: 'refBlocks',
                label: '참고 블록',
                type: 'cards',
                itemLabel: '블록',
                subfields: [
                  { key: 'heading', label: '제목', type: 'text' },
                  { key: 'items', label: '항목 목록', type: 'list' },
                ],
              },
            ],
            value: [
              {
                title: '국방 & 항공우주',
                meta: '정밀 타격 · C2 · 감시 · 무인 체계',
                lessons: [
                  {
                    title: '견고한 임베디드 시스템',
                    desc: '정밀 타격, 지휘통제(C2), 감시, 지상/무인 차량, 공중/UAV, 해상/수중 플랫폼을 위한 VPX, VME, CompactPCI 보드.',
                    tag: 'Abaco',
                  },
                  {
                    title: '디지털 신호 처리',
                    desc: '레이더, 전자전(EW), 신호정보(SIGINT)를 위한 Jade, Cobalt, Onyx, Talon, Flexor, Spark DSP 플랫폼.',
                    tag: 'DSP',
                  },
                ],
                refBlocks: [
                  {
                    heading: '플랫폼 & 사업',
                    items: [
                      '정밀 타격 — 현무, 해성, 신궁, 천궁',
                      '해상 — KNTDS, FFX Series, C4I, KSS-III, JTDLS, KDX-I PIP, KDX, PKX, MLS, LST, ATX, LPH',
                      '항공 — UAV/GCS, 중고도 무인기(MUAV)',
                      '지상 — K2, K21 제어 시스템',
                      'C2 — 위성 통신, 정찰, 전자전/재밍',
                      '감시 — 열상 관측, 영상/탐색 레이더, 표적 탐지',
                      '응용 — 항공우주/위성, 비행/함정 시뮬레이터, 유도탄 제어, 사격 통제, MIL 시험 장비, 영상/신호 처리, 레이더/소나',
                    ],
                  },
                  {
                    heading: '주요 납품 실적',
                    items: [
                      'C4I 성능 개량 — 울산급 호위함, 광개토-III (STX엔진)',
                      'KSS-III Batch-III 잠수함 C4I 시스템 (STX엔진)',
                      'Rugged Server 개발 — 한화시스템',
                      'C4I 시스템 성능 개량 부품 — 한화시스템',
                      'Radar Target Simulator (RTS) — LIG넥스원',
                      '기뢰 탐지 소나 통합 시뮬레이터 — LIG넥스원',
                      '잠수함 감시 시스템 국산화 — 대우조선해양',
                      'OKTAL-SE SE-Workbench-RF & SE-RAY-SAR — 국방과학연구소',
                      '함정 데이터 수집 시스템 — Fanless BoxIPC',
                      'K2 폴란드 수출용 VxWorks 공급 계약 — 현대로템',
                      'FEPOL CPU 보드 & VxWorks 7.0 BSP 개발',
                      'BITU 시스템용 VxWorks BSP — LS일렉트릭',
                      '지상 전술 C4I 시스템 — 방위사업청',
                      '해군 모니터링 콘솔 ACE-PPC-23H — 양산',
                      '임베디드 시스템 — 현대중공업',
                      '센서 시스템 — 삼성탈레스 (현 한화시스템)',
                      '전투 체계 — 한화디펜스',
                      'VxWorks & 미들웨어 — LIG시스템',
                      '두산중공업 — 제어 시스템',
                      '인천국제공항 — 인프라 시스템',
                    ],
                  },
                ],
              },
              {
                title: '철도 교통',
                meta: 'CBTC · PTC · ATP · ATO · ATS · 연동',
                lessons: [
                  {
                    title: 'HIMA HiMax System',
                    desc: '열차 관제 센터, CBTC, PTC, ATP, ATO, ATS 및 전자 연동 응용을 위한 유연한 COTS 제어 시스템. 30년 이상의 철도 전문성. 신규 설치는 물론 기존 시스템의 확장에도 적합한 확장형 모듈 솔루션.',
                    tag: 'HIMA',
                  },
                  {
                    title: 'ControlSafe™ Platform',
                    desc: '철도 신호, 열차 제어, 전자 폐색 시스템을 위한 TÜV SÜD SIL4 인증 페일세이프 내결함성 시스템. EN 50126(RAMS), EN 50128(안전 소프트웨어), EN 50129(안전 하드웨어)를 준수.',
                    tag: 'SIL4',
                  },
                ],
                refBlocks: [
                  {
                    heading: '적용 분야',
                    items: [
                      '열차 제어 신호 시스템',
                      '전자 연동 장치 (CBI)',
                      '무선 기반 열차 제어 (CBTC)',
                      'Positive Train Control (PTC)',
                      'ATP / ATO / ATS',
                      'RBC — 무선 폐색 센터',
                      'TSRS — 임시 속도 제한 서버',
                      'TCC — 열차 관제 센터',
                      '전자 연동 / ETCS / EABS',
                    ],
                  },
                  {
                    heading: '주요 납품 실적',
                    items: [
                      'ControlSafe EXB 전자 연동 — 유경제어',
                      'ControlSafe CCC 전자 연동 — 혁신샬롬엔지니어링',
                      '철도 TCMS용 ISaGRAF 시스템 — 해외 프로젝트',
                      'ISaGRAF 시스템 — VITZROSYS & 인텔릭스',
                      '원자력 프로젝트용 ISaGRAF — 전체 구성',
                      '스마트 철도 건널목 장애물 검지 시스템',
                      '철도 신호 표시 제어 시스템 — 산업용 PC',
                      '건널목 레이저 장애물 검지 — 한국철도기술연구원',
                      '전자 연동 표시 제어 — 코레일',
                    ],
                  },
                ],
              },
              {
                title: '통신 & 네트워킹',
                meta: '위성 · 영상 처리 · 데이터 압축',
                lessons: [
                  {
                    title: '네트워크 어플라이언스',
                    desc: '위성/음성 통신, 영상 처리, 데이터 압축 응용을 위한 엔트리급부터 하이엔드급까지의 네트워크 어플라이언스.',
                    tag: 'Network',
                  },
                  {
                    title: 'NIC 어댑터',
                    desc: '데이터센터, 통신 인프라, RTOS 기반 시스템을 위한 고성능 네트워크 인터페이스 카드.',
                    tag: 'NIC',
                  },
                ],
                refBlocks: [
                  {
                    heading: '적용 분야',
                    items: [
                      '슈퍼컴퓨팅 솔루션 / 고성능 컴퓨팅',
                      '위성 음성 & 데이터 중계 응용',
                      '음성 / 데이터 압축 응용',
                      '영상 처리 시스템',
                      'RTOS 제품 및 전문 BSP/드라이버 포팅 서비스',
                    ],
                  },
                  {
                    heading: '주요 납품 실적',
                    items: [
                      '1U 서버 & 이중 네트워크 보안 시스템 — 소프트위드솔루션',
                      '네트워크 보안 솔루션 — 외교부',
                      '지능형 선박 장비용 HiEMS 서버 — 현대삼호',
                      'NAC 보안 솔루션 어플라이언스 — JUVIS',
                      '보안 솔루션 — 공공·금융·기업 부문',
                      'SMB급 네트워크 어플라이언스 — 채울',
                    ],
                  },
                ],
              },
              {
                title: '자동화 & 산업',
                meta: '가속기 · 방송 · 발전 · 데이터 처리',
                lessons: [
                  {
                    title: '산업용 팬리스 PC',
                    desc: '행정 전산망, 군용, 공장 HMI, 철강 제조, 철도/열차 제어, 설비 자동화, 반도체/제조 품질 검사, 키오스크, 디지털 사이니지, 보안 & 감시, IoT 등에 적용되는 KC 인증 팬리스 PC — 국내 300개 이상의 정부 기관에 공급.',
                    tag: 'IPC',
                  },
                  {
                    title: '공정 제어 & 자동화',
                    desc: '가속기, 방송 시스템, 발전 제어, 산업용 차량, 대용량 데이터 처리를 위한 컴퓨팅 플랫폼.',
                    tag: 'Automation',
                  },
                ],
                refBlocks: [
                  {
                    heading: '적용 분야',
                    items: [
                      '포항 4세대 / 양성자 / 중이온 가속기',
                      '방송 & 방송 송출 시스템',
                      '발전 제어 — DSC / SCADA / RTU / 스마트 그리드 / ESS / HVDC',
                      '원자력 발전소 — DCS / 이중화',
                      '가속기 시스템 — 타이밍 빔 라인',
                    ],
                  },
                  {
                    heading: '주요 납품 실적',
                    items: [
                      '제2후판공장 에어컴프 시스템 — POSCO 포항',
                      '열연 라인 시효 제어 시스템 — POSCO DX',
                      'HMI 시스템 — POSCO 포항',
                      'AGV HMI & 냉연 라인 PC — POSCO 광양 (Iba Korea 경유)',
                      'Fanless BoxIPC 출입 통제 — 현대제철 당진',
                      '음성 인식 평가 시스템 — 현대모비스',
                      'Fanless Rackmount 산업용 PC — 현대자동차 전주',
                      '발전 제어 모듈용 실시간 OS — 두산에너빌리티',
                      '반도체 장비 분석 시스템 — 삼성전자',
                      'PLC 통신 모듈 시험 — LG이노텍',
                      'Fanless 산업용 PC — 금호타이어 광주공장',
                      '4U Rackmount 산업용 PC — SK하이닉스',
                      '산업용 PC — 동국제강 포항',
                      '산업 시스템 — POSCO ICT',
                      '주차 관제 시스템 — 롯데몰 & 롯데프리미엄아울렛',
                    ],
                  },
                ],
              },
              {
                title: '센서 모델링 & 시뮬레이션',
                meta: 'EO/IR · RF · Active EO · GNSS · HWIL · MITL',
                lessons: [
                  {
                    title: 'EO/IR, RF & Active EO 시뮬레이션',
                    desc: '다중 센서 시뮬레이션을 위한 물리 기반 COTS 소프트웨어 — SE-Workbench-EO, SE-Workbench-HWIL-EO, SE-Workbench-EOS, SE-Workbench-RF, SE-Workbench-SAR 등. DGA, ONERA, MBDA, SAFRAN-SAGEM과 25년간의 파트너십.',
                    tag: 'OKTAL-SE',
                  },
                  {
                    title: '3D 지형, 데이터베이스 & API',
                    desc: '실시간 3D 지형 및 건물 생성(SE-3D-DB), 장면 데이터베이스, 특수 효과, 훈련 시뮬레이션·임무 예행연습·UAV 관제소·합성 전장 제작을 위한 통합 API.',
                    tag: '3D',
                  },
                ],
                refBlocks: [
                  {
                    heading: '주요 납품 실적',
                    items: [
                      'SE-SEA-DB SAR 기능 강화 — 국방과학연구소',
                      'SE-Workbench-RF & SE-RAY-SAR 유지보수 — ADD',
                      '신규 SGW용 SE-Workbench-EO — LIG넥스원',
                      'SE-TK-D-SCNX-TEL & 3D 모델 — 국방과학연구소',
                      'AI 연구용 IR 영상 생성 — OKTAL-SE',
                      '다중 파장 영상 데이터 처리 — 공동 R&D',
                    ],
                  },
                ],
              },
              {
                title: '고성능 컴퓨팅 (HPC)',
                meta: 'GPU · 컴퓨팅 · 확장',
                lessons: [
                  {
                    title: 'GPU 서버 & 어플라이언스',
                    desc: 'AI 추론, 딥러닝, 과학 연산을 위한 고밀도 GPU 컴퓨팅 플랫폼.',
                    tag: 'GPU',
                  },
                  {
                    title: 'PCIe 확장 & 스토리지',
                    desc: 'One Stop Systems PCIe 확장 섀시 및 고성능 NVMe 스토리지 솔루션.',
                    tag: 'OSS',
                  },
                ],
                refBlocks: [
                  {
                    heading: '적용 분야',
                    items: [
                      '머신러닝 — 딥러닝, 영상 인식, 자율주행, 실시간 음성 번역',
                      '금융 — 몬테카를로 시뮬레이션, 고빈도 매매(HFT), 편미분 방정식, 리스크 분석',
                      '국방 — 지리공간 시각화, 정보 분석, SAAR',
                      '미디어 — 영상 저장, 렌더링, 색 보정',
                      '의료 — 영상 처리, 생물정보학, 시뮬레이션',
                      '연구 — 분자동역학, 수치 해석, 기상 & 기후 예측',
                      '석유 & 가스 — 탄성파 처리, 저류층 모델링',
                    ],
                  },
                  {
                    heading: '주요 납품 실적',
                    items: [
                      '2세대 Xeon 1U 서버 — 외교부 데이터센터',
                      'Xeon 1U 서버 보안 솔루션 — 푸본현대생명',
                      '가속기용 mTCA — HUMANTECH',
                      'PENTEK 가속기 — 한국원자력연구원',
                      '40U 10노드 슈퍼컴퓨팅 시스템 (맞춤 제작)',
                    ],
                  },
                ],
              },
              {
                title: 'R&D 센터',
                meta: '영상 처리 · GPU · FPGA · 임베디드 설계',
                lessons: [
                  {
                    title: '알고리즘 & 시스템 설계',
                    desc: '영상 처리 알고리즘 연구(안정화, 파노라마, 추적, 칼만 필터), GPU 기반 고속 영상 처리, FPGA IP 설계, 적외선 시뮬레이션, 고성능 임베디드 시스템 개발.',
                    tag: 'R&D',
                  },
                  {
                    title: '맞춤 통합 & 지원',
                    desc: '컨설팅부터 구축까지 엔드투엔드 맞춤형 하드웨어 설계, 시스템 통합, 전 주기 기술 지원.',
                    tag: 'Support',
                  },
                ],
                refBlocks: [
                  {
                    heading: '핵심 기술',
                    items: [
                      '비전 기반 항법, 유도 & 실시간 표적 추적',
                      '영상 처리 알고리즘의 FPGA 구현 (IP 설계, Matlab/Simulink, C2HDL)',
                      '시뮬레이터 호스트 컴퓨터 — 항공기, 전차 사격 훈련, CSC & RTU',
                      '비행 시험 통제 & 위성 발사 통제',
                      'VME/VPX 시스템 설계 & RTOS BSP/드라이버 포팅',
                      'Fanless 방열 기술 — 히트파이프 & 히트싱크 최적화',
                      '내진동 구조 & 방진 설계',
                    ],
                  },
                  {
                    heading: '주요 납품 실적',
                    items: [
                      '디지털 건설기계용 SDM 플랫폼 — 국가 R&D',
                      '실시간 컴퓨터 시스템 — 국방과학연구소',
                      '미국 특허 — 자연 냉각형 산업용 컴퓨터',
                      '특허 — 열전소자 적용 냉각핀 (2020)',
                      'ISO-9001:2015 · KC 인증 · K마크 · CE · FCC',
                      '1994년 이래 국내 300개 이상 기관에 공급',
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 'apps-faq',
        title: '자주 묻는 질문 (FAQ)',
        fields: [
          {
            key: 'faqs',
            label: 'FAQ',
            type: 'cards',
            itemLabel: 'FAQ',
            subfields: [
              { key: 'q', label: '질문', type: 'text' },
              { key: 'a', label: '답변', type: 'textarea' },
            ],
            value: [
              {
                q: 'AceTec은 어떤 산업 분야를 지원하나요?',
                a: 'AceTec은 국방 & 항공우주, 철도 교통, 통신 & 네트워킹, 산업 자동화, 고성능 컴퓨팅, 센서 시뮬레이션 분야를 지원하며, 주로 한국과 아시아·태평양 지역을 대상으로 합니다.',
              },
              {
                q: '맞춤형 솔루션을 제공하나요?',
                a: '네. 당사 R&D 센터와 엔지니어링 팀이 고객의 구체적인 프로젝트 요구사항에 맞춘 맞춤형 시스템 통합, 하드웨어 개조, 소프트웨어 개발 서비스를 제공합니다.',
              },
              {
                q: '제품은 어떤 인증을 보유하고 있나요?',
                a: '제품군에 따라 KC(한국 인증), ISO 9001 품질경영, 철도 안전 시스템에 대한 TÜV SÜD SIL4, 국방 등급 하드웨어에 대한 MIL-STD 준수 등의 인증을 보유하고 있습니다.',
              },
              {
                q: '제품 시연은 어떻게 요청하나요?',
                a: '문의 양식을 통해 신청하시거나 직접 전화 주시면 됩니다. 당사 기술팀이 현장 시연, 원격 세션을 마련하거나 적격 프로젝트에 대해 평가용 장비를 제공해 드립니다.',
              },
            ],
          },
        ],
      },
    ],
  },

  /* ───────────────────────── 교육 신청 ───────────────────────── */
  {
    id: 'education',
    label: '교육 신청',
    previewPath: '/education',
    sections: [
      {
        id: 'edu-header',
        title: '페이지 헤더',
        fields: [
          { key: 'title', label: '페이지 제목', type: 'text', value: '교육 신청' },
          {
            key: 'subtitle',
            label: '부제목',
            type: 'textarea',
            value: 'Real-Time Embedded System 개발자를 위한 교육으로, 강의와 실습을 병행하여 진행됩니다.',
          },
        ],
      },
      {
        id: 'edu-courses',
        title: '교육 과정',
        fields: [
          {
            key: 'courses',
            label: '과정',
            type: 'cards',
            itemLabel: '과정',
            subfields: [
              { key: 'name', label: '과정명', type: 'text' },
              { key: 'price', label: '수강료', type: 'text' },
              { key: 'duration', label: '교육 기간', type: 'text' },
              { key: 'schedule', label: '일정 안내', type: 'text' },
            ],
            value: [
              {
                name: 'Workbench 4 (VxWorks 7) 정기 교육',
                price: '1,300,000원',
                duration: '5일',
                schedule: '3차 일정 9/15 ~ 9/19 (그 외 차수 마감)',
              },
              {
                name: 'Workbench 3.3 (VxWorks 6.9)',
                price: '1,300,000원',
                duration: '5일',
                schedule: '최소 5인 모집 시 진행 · 문의 02-420-2343',
              },
              {
                name: 'BSP (VxWorks 6.x)',
                price: '1,300,000원',
                duration: '4일',
                schedule: '최소 5인 모집 시 진행 · 문의 02-420-2343',
              },
              {
                name: 'Tornado 2.2 (VxWorks 5.5)',
                price: '1,300,000원',
                duration: '4일',
                schedule: '최소 5인 모집 시 진행 · 문의 02-420-2343',
              },
            ],
          },
        ],
      },
      {
        id: 'edu-contact',
        title: '교육 문의',
        fields: [
          { key: 'title', label: '섹션 제목', type: 'text', value: '교육 문의' },
          { key: 'emailLabel', label: '이메일 레이블', type: 'text', value: '이메일 문의' },
          { key: 'email', label: '이메일 주소', type: 'text', value: 'service@acetec-korea.co.kr' },
          { key: 'telLabel', label: '전화 레이블', type: 'text', value: '교육 신청 문의' },
          { key: 'tel', label: '전화번호', type: 'text', value: '02-420-2343 (내선 721)' },
          { key: 'instructor', label: '강사', type: 'text', value: '강사: 이은옥 (컴퓨터시스템응용기술사)' },
          {
            key: 'place',
            label: '교육 장소',
            type: 'text',
            value: '교육 장소: 서울특별시 구로구 디지털로26길 61, 에이스하이엔드타워 2차 603호',
          },
          { key: 'contact', label: '연락처', type: 'text', value: 'TEL: 02-420-2343 (내선 721) · FAX: 02-420-2757' },
          {
            key: 'notice',
            label: '교육 공지사항',
            type: 'textarea',
            value:
              '※ 교육 2~3일 전에 개설 여부를 개별 통보해 드립니다. 행정 업무 관리상, 교육 개설 확정 통보 이후에는 취소가 불가하오니 신청 시 신중을 기해 주시기 바랍니다.',
          },
        ],
      },
    ],
  },

  /* ───────────────────────── 회사 소개 ───────────────────────── */
  {
    id: 'about',
    label: '회사 소개',
    previewPath: '/about',
    sections: [
      {
        id: 'about-hero',
        title: '페이지 헤더',
        fields: [
          { key: 'title', label: '페이지 제목', type: 'text', value: '회사 소개' },
          {
            key: 'intro1',
            label: '메인 소개 문구 1',
            type: 'textarea',
            value:
              '30년이 넘는 세월 동안 AceTec은 글로벌 임베디드 기술과 한국에서 가장 까다로운 산업 분야가 만나는 지점에 서 있었습니다. 전문 유통사로 시작한 AceTec은 이제 세계 최고 수준의 하드웨어와 소프트웨어를 공급할 뿐 아니라, 자체 R&D 센터를 통해 맞춤형 솔루션을 처음부터 직접 설계하는 풀스펙트럼 기술 파트너로 성장했습니다.',
          },
          {
            key: 'intro2',
            label: '메인 소개 문구 2',
            type: 'textarea',
            value:
              'AceTec은 국내 최초의 데스크탑형 팬리스 산업용 PC를 개척하여, 지금도 우리의 방식을 정의하는 업계 기준을 세웠습니다 — 견고하고 목적에 맞게 설계된 기술로 실제 문제를 해결한다는 원칙입니다. 오늘날 당사의 플랫폼은 함정 전투 체계, 철도 연동 네트워크, 제철소 생산 라인, 국방 시뮬레이션 환경 등 실패가 용납되지 않는 모든 현장에서 운용되고 있습니다.',
          },
          {
            key: 'intro3',
            label: '메인 소개 문구 3',
            type: 'textarea',
            value:
              'Abaco Systems, HIMA, Wind River, RTI, OKTAL-SE, Cambridge Pixel, OneStopSystems, Pentek, SMART Embedded Computing와의 전략적 파트너십을 바탕으로, 검증된 글로벌 기술과 깊이 있는 국내 엔지니어링 전문성을 함께 제공합니다. 국방과학연구소(ADD)와 POSCO부터 현대, 한화시스템에 이르는 고객들이 우리를 신뢰하는 이유는, 단순한 제품이 아니라 성과를 제공하기 때문입니다.',
          },
        ],
      },
      {
        id: 'about-stats',
        title: '주요 통계',
        fields: [
          {
            key: 'stats',
            label: '통계',
            type: 'cards',
            itemLabel: '통계',
            subfields: [
              { key: 'num', label: '숫자', type: 'text' },
              { key: 'label', label: '레이블', type: 'text' },
            ],
            value: [
              { num: '30+', label: '임베디드 컴퓨팅 경력' },
              { num: '487+', label: '프로젝트 납품' },
              { num: '300+', label: '고객 기관' },
              { num: '9', label: '글로벌 기술 파트너' },
            ],
          },
        ],
      },
      {
        id: 'about-ceo',
        title: 'CEO 인사말',
        fields: [
          { key: 'title', label: '섹션 제목', type: 'text', value: 'CEO 인사말' },
          {
            key: 'quote',
            label: '인용문',
            type: 'textarea',
            value: '"우리의 사명은 실패가 결코 용납되지 않는 곳에 가장 신뢰할 수 있는 임베디드 솔루션을 제공하는 것입니다."',
          },
          {
            key: 'body1',
            label: '본문 1',
            type: 'textarea',
            value:
              '1994년 창립 이래 AceTec은 30년 넘게 임베디드 컴퓨팅 산업에서 깊은 전문성을 쌓아왔습니다. 세계 최고 수준의 임베디드 기술을 한국에서 가장 까다로운 분야에 도입하겠다는 비전으로 출발했으며, 오늘날 그 비전은 우리의 모든 활동을 이끌고 있습니다.',
          },
          {
            key: 'body2',
            label: '본문 2',
            type: 'textarea',
            value:
              '당사는 국내 최초로 데스크탑형 팬리스 산업용 PC를 개발했으며, 자연 냉각 기술로 미국 특허를 취득했습니다. 이러한 개척 정신은 지금도 우리를 정의합니다 — 우리는 단순히 기술을 유통하는 것이 아니라, 고객이 자신의 운영을 믿고 맡길 수 있는 솔루션을 설계합니다.',
          },
          {
            key: 'body3',
            label: '본문 3',
            type: 'textarea',
            value:
              'Abaco Systems, HIMA, Wind River, RTI 등 세계 유수 기업과의 전략적 파트너십을 통해, 검증된 국제 기술과 당사의 깊이 있는 국내 엔지니어링 전문성을 결합합니다. 자체 R&D 센터를 통해 모든 솔루션을 현장에 투입하기 전에 맞춤화하고 검증합니다.',
          },
          {
            key: 'body4',
            label: '본문 4',
            type: 'textarea',
            value:
              '임베디드 시스템이 국방, 교통, 에너지, 산업 자동화에서 점점 더 중요해지는 가운데, AceTec은 가장 중요한 순간에 제 역할을 하는 기술을 제공하는 신뢰받는 파트너로 계속 성장해 나가겠습니다.',
          },
          { key: 'sign', label: '서명', type: 'text', value: '— AceTec 주식회사 대표이사' },
          {
            key: 'highlights',
            label: '하이라이트 카드',
            type: 'cards',
            itemLabel: '카드',
            subfields: [
              { key: 'title', label: '제목', type: 'text' },
              { key: 'desc', label: '설명', type: 'textarea' },
            ],
            value: [
              { title: '국내 최초', desc: '미국 특허 자연 냉각 기술을 적용한 데스크탑형 팬리스 산업용 PC' },
              { title: '자체 R&D 센터', desc: '맞춤형 임베디드 솔루션을 위한 자체 연구개발' },
              { title: '인증된 품질', desc: 'ISO-9001, KC 인증, K마크, SIL4 안전 무결성' },
            ],
          },
        ],
      },
      {
        id: 'about-philosophy',
        title: '경영 이념',
        fields: [
          { key: 'title', label: '섹션 제목', type: 'text', value: '경영 이념' },
          { key: 'subtitle', label: '부제목', type: 'text', value: '우리의 모든 의사결정을 이끄는 세 가지 원칙' },
          {
            key: 'items',
            label: '원칙',
            type: 'cards',
            itemLabel: '원칙',
            subfields: [
              { key: 'no', label: '순번', type: 'text' },
              { key: 'title', label: '제목', type: 'text' },
              { key: 'desc', label: '설명', type: 'textarea' },
            ],
            value: [
              {
                no: '01',
                title: '고객 만족',
                desc: '우리는 고객의 성공을 사업의 중심에 둡니다. 모든 제품, 모든 프로젝트, 모든 지원은 한 가지 기준으로 평가됩니다 — 기대를 뛰어넘었는가? 300개 이상의 기관 고객과 487건 이상의 프로젝트 납품이 성과에 대한 우리의 끊임없는 헌신을 보여줍니다.',
              },
              {
                no: '02',
                title: '소통 중심',
                desc: '기술 파트너십은 투명성과 신뢰 위에서 성장합니다. 우리는 고객 및 글로벌 파트너 모두와 열린, 능동적인 소통을 유지하여 요구사항을 정확히 이해하고, 일정을 준수하며, 문제가 되기 전에 과제를 해결합니다.',
              },
              {
                no: '03',
                title: '기술 중심',
                desc: '본질적으로 우리는 엔지니어입니다. 지속적으로 R&D에 투자하고, 임베디드 플랫폼 전반에 걸친 깊은 기술 전문성을 유지하며, 업계의 변화를 앞서갑니다. VxWorks BSP 포팅부터 SIL4 인증 안전 시스템까지, 우리의 기술적 깊이가 곧 경쟁력입니다.',
              },
            ],
          },
        ],
      },
      {
        id: 'about-culture',
        title: '기업 문화',
        fields: [
          { key: 'title', label: '섹션 제목', type: 'text', value: '기업 문화' },
          { key: 'subtitle', label: '부제목', type: 'text', value: '우리가 함께 일하고 성장하는 방식을 정의하는 가치' },
          {
            key: 'items',
            label: '가치',
            type: 'cards',
            itemLabel: '가치',
            subfields: [
              { key: 'title', label: '제목', type: 'text' },
              { key: 'desc', label: '설명', type: 'textarea' },
            ],
            value: [
              {
                title: '창의',
                desc: '우리는 혁신적인 사고와 창의적인 문제 해결을 장려합니다. 표준 솔루션으로 충분하지 않을 때, 우리는 새로운 것을 만들어냅니다 — 국가적 기준을 세운 특허받은 팬리스 냉각 기술처럼.',
              },
              {
                title: '사랑',
                desc: '기술에 대한 열정과 사람에 대한 배려. 우리는 전문성이 공유되고 멘토십이 존중되며 모든 구성원이 공동의 사명에 기여하는 든든한 환경을 만들어 갑니다.',
              },
              {
                title: '도전',
                desc: '우리는 어려운 문제를 기꺼이 받아들입니다. 미션 크리티컬 국방 시스템부터 원자력 발전소 제어까지, 가장 높은 기준을 요구하는 프로젝트에 도전하고 매번 성과를 냅니다.',
              },
            ],
          },
        ],
      },
      {
        id: 'about-cta',
        title: '함께하기 (CTA)',
        fields: [
          { key: 'title', label: '섹션 제목', type: 'text', value: '함께하기' },
          {
            key: 'desc',
            label: '설명',
            type: 'textarea',
            value:
              '다음 프로그램을 위한 기술 파트너를 찾고 계신가요? 요구사항을 보내주시면 당사 팀이 영업일 기준 1일 이내에 회신드립니다.',
          },
        ],
      },
    ],
  },

  /* ───────────────────────── 파트너사 ───────────────────────── */
  {
    id: 'partners',
    label: '파트너사',
    previewPath: '/partners',
    sections: [
      {
        id: 'partners-header',
        title: '페이지 헤더',
        fields: [
          { key: 'title', label: '페이지 제목', type: 'text', value: '파트너사' },
          {
            key: 'desc',
            label: '페이지 설명',
            type: 'textarea',
            value:
              'AceTec은 세계 유수의 기술 기업들과의 전략적 파트너십을 통해, 검증된 글로벌 기술과 깊이 있는 국내 엔지니어링 전문성을 결합하여 미션 크리티컬 솔루션을 제공합니다.',
          },
        ],
      },
      {
        id: 'partners-cards',
        title: '파트너사 카드',
        fields: [
          {
            key: 'partners',
            label: '파트너사',
            type: 'cards',
            itemLabel: '파트너사',
            subfields: [
              { key: 'name', label: '파트너명', type: 'text' },
              { key: 'category', label: '카테고리', type: 'text' },
              { key: 'desc', label: '설명', type: 'textarea' },
            ],
            value: [
              { name: 'Abaco Systems', category: 'Defense-Grade Embedded', desc: '국방·항공우주용 견고한 VPX/VME 보드 및 임베디드 신호 처리 플랫폼.' },
              { name: 'HIMA', category: 'Railway Safety (SIL4)', desc: 'TÜV SÜD SIL4 인증 ControlSafe™ 철도 안전·신호 제어 플랫폼.' },
              { name: 'Wind River', category: 'RTOS & Software', desc: 'VxWorks, Wind River Linux, Simics 등 임베디드 운영체제·소프트웨어.' },
              { name: 'One Stop Systems', category: 'PCIe Expansion & GPU', desc: '고밀도 GPU 확장 섀시, PCIe 스위칭, 고성능 NVMe 스토리지.' },
              { name: 'RTI', category: 'DDS Middleware', desc: 'Connext DDS 실시간 통신 미들웨어.' },
              { name: 'OKTAL-SE', category: 'Sensor Simulation', desc: 'EO/IR/RF 센서 모델링·시뮬레이션 (SE-Workbench).' },
              { name: 'Cambridge Pixel', category: 'Radar Processing', desc: 'SPx 레이더 신호 처리 및 디스플레이 솔루션.' },
              { name: 'Pentek', category: 'Data Conversion & SDR', desc: '고성능 데이터 변환 및 소프트웨어 정의 라디오(SDR) 보드.' },
            ],
          },
        ],
      },
      {
        id: 'partners-cta',
        title: '파트너십 문의',
        fields: [
          { key: 'title', label: '섹션 제목', type: 'text', value: '파트너십 문의' },
          {
            key: 'desc',
            label: '설명',
            type: 'textarea',
            value:
              '기술 협력 또는 파트너십에 관심이 있으신가요? 요구사항을 보내주시면 당사 팀이 영업일 기준 1일 이내에 회신드립니다.',
          },
        ],
      },
    ],
  },

  /* ───────────────────────── 연혁 ───────────────────────── */
  {
    id: 'history',
    label: '연혁',
    previewPath: '/history',
    sections: [
      {
        id: 'history-header',
        title: '페이지 헤더',
        fields: [
          { key: 'title', label: '페이지 제목', type: 'text', value: '연혁 & 실적' },
          {
            key: 'subtitle',
            label: '부제목',
            type: 'textarea',
            value: '임베디드 컴퓨팅, 국방 시스템, 산업 기술 분야에서 30년 이상의 혁신 — 1994년부터 현재까지.',
          },
        ],
      },
      {
        id: 'history-note',
        title: '연혁 데이터 (안내)',
        note:
          '연혁 항목은 1994~2024년 1,300건 이상으로 데이터(history.ts)에 저장되어 있습니다. 대량 데이터 편집 UI는 별도 화면으로 분리 예정입니다. (현재는 헤더 문구만 편집 가능)',
        fields: [],
      },
    ],
  },

  /* ───────────────────────── 오시는 길 ───────────────────────── */
  {
    id: 'contact',
    label: '오시는 길',
    previewPath: '/contact',
    sections: [
      {
        id: 'contact-header',
        title: '페이지 헤더',
        fields: [
          { key: 'title', label: '페이지 제목', type: 'text', value: '오시는 길' },
          {
            key: 'subtitle',
            label: '부제목',
            type: 'textarea',
            value: '제품 문의, 기술 상담, 파트너십 기회 등 무엇이든 당사 팀이 도와드립니다.',
          },
        ],
      },
      {
        id: 'contact-offices',
        title: '오피스 정보',
        fields: [
          {
            key: 'offices',
            label: '오피스',
            type: 'cards',
            itemLabel: '오피스',
            subfields: [
              { key: 'name', label: '오피스명', type: 'text' },
              { key: 'addr', label: '주소', type: 'textarea' },
              { key: 'email', label: '이메일', type: 'text' },
              { key: 'tel', label: '전화', type: 'text' },
              { key: 'fax', label: '팩스', type: 'text' },
            ],
            value: [
              {
                name: '서울 본사',
                addr: '서울특별시 구로구 디지털로26길 61, 에이스하이엔드타워 2차 603호',
                email: 'acetec@acetec-korea.co.kr',
                tel: '전화: +82-2-420-2343',
                fax: '팩스: +82-2-420-2757',
              },
              {
                name: '대전 지사',
                addr: '대전광역시 유성구 테크노2로 199, 미건테크노월드 205호',
                email: '',
                tel: '전화: +82-42-471-2343',
                fax: '팩스: +82-42-933-2642',
              },
            ],
          },
        ],
      },
    ],
  },

  /* ───────────────────────── 문의하기 ───────────────────────── */
  {
    id: 'inquiry',
    label: '문의하기',
    previewPath: '/inquiry',
    sections: [
      {
        id: 'inquiry-header',
        title: '페이지 헤더',
        fields: [
          { key: 'title', label: '페이지 제목', type: 'text', value: '문의하기' },
          {
            key: 'desc',
            label: '페이지 설명',
            type: 'textarea',
            value:
              '제품 견적, 기술 상담, 파트너십 등 어떤 문의든 환영합니다. 아래 양식을 작성해 주시면, 당사 엔지니어링 팀이 영업일 기준 1일 이내에 회신드립니다.',
          },
          { key: 'email', label: '이메일', type: 'text', value: 'acetec@acetec-korea.co.kr' },
          { key: 'tel', label: '전화', type: 'text', value: '전화: +82-2-420-2343' },
          { key: 'fax', label: '팩스', type: 'text', value: '팩스: +82-2-420-2757' },
        ],
      },
    ],
  },

  /* ───────────────────────── 푸터 ───────────────────────── */
  {
    id: 'footer',
    label: '푸터',
    previewPath: '/',
    sections: [
      {
        id: 'footer-company',
        title: '회사 정보',
        fields: [
          { key: 'title', label: '회사명', type: 'text', value: 'AceTec' },
          {
            key: 'desc',
            label: '회사 설명',
            type: 'textarea',
            value:
              '임베디드 컴퓨팅, 산업용 PC, 안전 필수 시스템 분야에서 30년 이상 신뢰받아 온 기업으로, 국방·항공우주·철도·산업 시장에 솔루션을 제공합니다.',
          },
          { key: 'hqLabel', label: '본사 레이블', type: 'text', value: '서울 본사' },
          { key: 'hqAddr', label: '본사 주소', type: 'textarea', value: '서울특별시 구로구 디지털로 26길 61 에이스하이엔드 2차 603호' },
          { key: 'hqEmail', label: '본사 이메일', type: 'text', value: 'acetec@acetec-korea.co.kr' },
          { key: 'hqTel', label: '본사 전화', type: 'text', value: '+82-2-420-2343' },
          { key: 'hqFax', label: '본사 팩스', type: 'text', value: 'FAX: +82-2-420-2757' },
          { key: 'djLabel', label: '대전 지사 레이블', type: 'text', value: '대전 지사' },
          { key: 'djAddr', label: '대전 지사 주소', type: 'textarea', value: '대전광역시 유성구 테크노2로 199, 미건테크노월드 205호' },
          { key: 'djTel', label: '대전 지사 전화', type: 'text', value: '+82-42-471-2343' },
          { key: 'djFax', label: '대전 지사 팩스', type: 'text', value: 'FAX: +82-42-933-2642' },
        ],
      },
      {
        id: 'footer-cols',
        title: '링크 컬럼',
        fields: [
          { key: 'solTitle', label: '솔루션 - 제목', type: 'text', value: '솔루션' },
          {
            key: 'solLinks',
            label: '솔루션 - 링크',
            type: 'list',
            value: ['국방 & 항공우주', '철도 교통', '산업 자동화', '통신 & 네트워킹', '센서 시뮬레이션', '고성능 컴퓨팅 (HPC)'],
          },
          { key: 'compTitle', label: '회사 - 제목', type: 'text', value: '회사' },
          {
            key: 'compLinks',
            label: '회사 - 링크',
            type: 'list',
            value: ['응용 분야', '적용 분야', '교육 신청', '회사 소개', '파트너사', '연혁', '오시는 길'],
          },
          { key: 'partTitle', label: '파트너사 - 제목', type: 'text', value: '파트너사' },
          {
            key: 'partLinks',
            label: '파트너사 - 링크',
            type: 'list',
            value: ['Abaco Systems', 'SMART Embedded Computing', 'OneStopSystems', 'Pentek', 'Wind River', 'OKTAL-SE', 'RTI', 'Cambridge Pixel'],
          },
        ],
      },
      {
        id: 'footer-bottom',
        title: '하단 정보',
        fields: [
          { key: 'company', label: '회사명', type: 'text', value: 'AceTec Co., Ltd.' },
          { key: 'ceo', label: '대표자', type: 'text', value: '대표: 장정훈' },
          { key: 'bizNo', label: '사업자등록번호', type: 'text', value: '사업자등록번호: 215-81-68464' },
          { key: 'copyright', label: '저작권', type: 'text', value: '© 2026 AceTec Co., Ltd. All rights reserved.' },
        ],
      },
    ],
  },
];
